import {t} from '@lingui/macro'
import {toast} from 'react-hot-toast'

export const errorResponseToast = (response: Response) =>
  toast.error(
    t`The response from the server was incorrect (${response.status}). Please try again later`
  )
